import React from "react";
import {connect} from "react-redux";
import {Col, Form, FormGroup, Row} from "react-bootstrap";
import PropTypes from "prop-types";
import {rd} from "../../../utils";



// component
class InternalMultipleCreditForm extends React.Component {

  static getTotalAmountFor(orderProducts) {
    let totalAmount = 0;
    for (const orderProduct of orderProducts) {
      if (orderProduct.checked) {
        totalAmount += orderProduct.pricePerUnitQuantity * orderProduct.quantity;
      }
    }
    return rd(totalAmount);
  }

  constructor(props) {
    super(props);

    this.state = {
      type: props.type,
      subTypeList: props.subTypeList,
      orderProducts: props.orderProducts,
      subtype: props.subtype,
      validate: props.validate,
      maxTotalAmount: props.maxTotalAmount,
      totalAmount: InternalMultipleCreditForm.getTotalAmountFor(props.orderProducts),
      submitted: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let notSameOrderProducts = false;
    if (nextProps.orderProducts.length !== prevState.orderProducts.length) {
      notSameOrderProducts = true;
    }
    else {
      for (let i = 0; i < nextProps.orderProducts.length; ++i) {
        if (nextProps.orderProducts[i].order_product_id !== prevState.orderProducts[i].order_product_id) {
          notSameOrderProducts = true;
          break;
        }
      }
    }

    if (
      nextProps.subTypeList !== prevState.subTypeList
      || notSameOrderProducts
    ) {
      return {
        subTypeList: nextProps.subTypeList,
        orderProducts: nextProps.orderProducts,
        validate: nextProps.validate,
        maxTotalAmount: nextProps.maxTotalAmount,
        // Sans ça, totalAmount conservait la valeur calculée pour la commande
        // précédente le temps qu'une interaction utilisateur le recalcule.
        totalAmount: InternalMultipleCreditForm.getTotalAmountFor(nextProps.orderProducts),
        submitted: false,
      };
    }
    return null;
  }

  /* Manage min and max quantity */
  handleQuantityChange(event) {
    const orderProductId = parseInt(event.target.dataset.orderProductId, 10);
    let quantity = event.target.value;
    const target = this.state.orderProducts.find(
      (op) => op.order_product_id === orderProductId,
    );
    if (!target) return;
    const { maxQuantity } = target;
    // Pendant la frappe on ne borne QUE le maximum. Appliquer le plancher
    // (minQuantity) à chaque caractère transformerait un "0" intermédiaire
    // — l'utilisateur tape "0.2" — en minQuantity et le bloquerait sur 0.01.
    // Le plancher est appliqué au blur, une fois la saisie terminée.
    // L'arrondi 2 décimales gère l'artefact flottant type 38.449999… du max.
    const parsed = parseFloat(quantity);
    if (!Number.isNaN(parsed) && parsed > maxQuantity) {
      quantity = rd(maxQuantity);
    }
    this.setQuantityFor(orderProductId, quantity);
  }

  handleQuantityBlur(event) {
    const orderProductId = parseInt(event.target.dataset.orderProductId, 10);
    const target = this.state.orderProducts.find(
      (op) => op.order_product_id === orderProductId,
    );
    if (!target) return;
    const { minQuantity, maxQuantity } = target;
    // À la sortie du champ, on borne définitivement dans [min, max]. Un champ
    // vide ou non numérique retombe sur le plancher.
    const parsed = parseFloat(event.target.value);
    let quantity;
    if (Number.isNaN(parsed) || parsed < minQuantity) {
      quantity = minQuantity;
    }
    else if (parsed > maxQuantity) {
      quantity = maxQuantity;
    }
    else {
      quantity = parsed;
    }
    this.setQuantityFor(orderProductId, rd(quantity));
  }

  setQuantityFor(orderProductId, quantity) {
    this.setState(function(state) {
      for (let orderProduct of state.orderProducts) {
        if (orderProduct.order_product_id === orderProductId) {
          orderProduct.quantity = quantity;
        }
      }
      return {
        orderProducts: state.orderProducts,
        totalAmount: InternalMultipleCreditForm.getTotalAmountFor(state.orderProducts),
        // Permet de re-soumettre si la précédente tentative a échoué.
        submitted: false,
      };
    });
  }

  handleSelectionChange(event) {
    let orderProductId = parseInt(event.target.dataset.orderProductId, 10);
    let checked = event.target.checked;
    this.setState(function(state, props) {
      for (let orderProduct of state.orderProducts) {
        if (orderProduct.order_product_id === orderProductId) {
          orderProduct.checked = checked;
        }
      }
      return {
        orderProducts: state.orderProducts,
        totalAmount: InternalMultipleCreditForm.getTotalAmountFor(state.orderProducts),
      };
    });
  }

  handleSubtypeChange(event) {
    let subtype = event.target.value;
    this.setState(function(state, props) {
      for (let orderProduct of state.orderProducts) {
        orderProduct.subtype = subtype;
      }
      return {
        orderProducts: state.orderProducts,
      };
    });
  }

  handleNotesChange(event) {
    let notes = event.target.value;
    this.setState(function(state, props) {
      for (let orderProduct of state.orderProducts) {
        orderProduct.notes = notes;
      }
      return {
        orderProducts: state.orderProducts,
      };
    });
  }

  handleSubmit(event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    if (this.state.submitted) {
      return;
    }
    this.setState({ submitted: true });
    this.state.validate(this.state.orderProducts);
  }

  render() {
    let classNames = "MultipleCredit metas";

    const hasCap =
      this.state.maxTotalAmount !== null
      && this.state.maxTotalAmount !== undefined;
    // Arrondi à 2 décimales pour aligner comparaisons et affichages : sinon
    // un cap brut 0.19999999999998863 (affiché "0,20€") bloquerait une
    // saisie de 0,20€.
    const roundedCap = hasCap ? rd(this.state.maxTotalAmount) : null;
    const isOverCap = hasCap && this.state.totalAmount > roundedCap;
    const capLabel = this.state.type === "credit"
      ? "Montant maximum recréditable sur cette commande"
      : "Montant maximum remboursable sur cette commande";

    return (
      <div className={classNames}>
        <Form onSubmit={this.handleSubmit.bind(this)} className="form-horizontal">
          {hasCap && (
            <div className="alert alert-info" role="alert">
              <b>{capLabel} : {roundedCap}€</b>
            </div>
          )}
          {isOverCap && (
            <div className="alert alert-danger" role="alert">
              <b>
                Le total saisi ({rd(this.state.totalAmount)}€) dépasse le
                montant autorisé ({roundedCap}€).
                Décochez un produit ou réduisez les quantités pour pouvoir valider.
              </b>
            </div>
          )}
          <table className="table table-condensed">
            <thead>
              <tr>
                <th></th>
                <th>Produit</th>
                <th>{this.state.type === "credit" ? "Quantité à recréditer" : "Quantité à rembourser"}</th>
                <th>Alertes</th>
              </tr>
            </thead>
            <tbody>
            {this.state.orderProducts ?
              this.state.orderProducts.map(
                orderProduct => {
                  // Si même une unité dépasse le plafond global de la
                  // commande, on grise la ligne — sinon l'utilisateur peut
                  // la cocher pour aussitôt voir le bouton de validation
                  // bloqué par le cap.
                  const unitPriceOverCap = hasCap
                    && orderProduct.pricePerUnitQuantity > 0
                    && rd(orderProduct.pricePerUnitQuantity) > roundedCap;
                  const rowDisabled = orderProduct.maxQuantity === 0 || unitPriceOverCap;
                  const overCapTitle = unitPriceOverCap
                    ? `Prix unitaire (${rd(orderProduct.pricePerUnitQuantity)}€) supérieur au montant autorisé (${roundedCap}€)`
                    : undefined;
                  return <tr key={orderProduct.order_product_id}>
                    <td title={overCapTitle}>
                      <input type="checkbox" value="1"
                        onChange={this.handleSelectionChange.bind(this)}
                        data-order-product-id={orderProduct.order_product_id}
                        disabled={rowDisabled}
                      />
                    </td>
                    <td title={overCapTitle}>
                      {orderProduct.selling_name}
                    </td>
                    <td>
                      <input
                          type="number"
                          name="quantity"
                          placeholder={this.state.type === "credit" ? "Quantité à recréditer" : "Quantité à rembourser"}
                          className="form-control"
                          required
                          step="any"
                          autoFocus={true}
                          onChange={this.handleQuantityChange.bind(this)}
                          onBlur={this.handleQuantityBlur.bind(this)}
                          data-order-product-id={orderProduct.order_product_id}
                          value={orderProduct.quantity}
                          min={orderProduct.minQuantity}
                          max={orderProduct.maxQuantity}
                          disabled={rowDisabled}
                          title={overCapTitle}
                      />
                    </td>
                    <td>
                      {orderProduct.alertWarning &&
                        <div className="alert alert-warning" role="alert"><b>{orderProduct.alertWarning}</b></div>
                      }
                      {orderProduct.alertInfo &&
                          <div className="alert alert-info" role="alert">{orderProduct.alertInfo}</div>
                      }
                      {unitPriceOverCap && (
                        <div className="alert alert-secondary" role="alert">
                          <small>
                            Prix unitaire trop élevé pour le montant restant à débloquer.
                          </small>
                        </div>
                      )}
                    </td>
                  </tr>;
                }
              )
              : null
            }
            </tbody>
          </table>
          <FormGroup as={Row} controlId="formControlsSelect">
            <Col as={Form.Label} sm={4}>
              Type de raison
            </Col>
            <Col sm={8}>
              <select
                  name="subtype"
                  onChange={this.handleSubtypeChange.bind(this)}
                  className="form-control"
                  required="required"
                  value={this.state.subtype}
              >
                <option value="">choisir</option>
                {this.state.subTypeList.map(e => (<option key={e.subtype} value={e.subtype}>{e.label}</option>))}
              </select>
            </Col>
          </FormGroup>
          <FormGroup as={Row} controlId="formControlsSelect">
            <Col as={Form.Label} sm={4}>
              Explications
            </Col>
            <Col sm={8}>
            <textarea
                name="notes"
                className="form-control"
                onBlur={this.handleNotesChange.bind(this)}
            />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={12} className="offset-sm-5">
              <button type="submit" className="btn btn-primary"
                      disabled={this.state.totalAmount === 0 || this.state.submitted || isOverCap}
              >
               {this.state.type === "credit" ? "Créditer" : "Rembourser"}  {this.state.totalAmount} €
              </button>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

InternalMultipleCreditForm.propTypes = {
  type: PropTypes.string,
  subTypeList: PropTypes.array.isRequired,
  orderProducts: PropTypes.array.isRequired,
  subtype: PropTypes.string,
  validate: PropTypes.func.isRequired,
  maxTotalAmount: PropTypes.number,
};

// link
export const MultipleCreditForm = connect(
  null,
  null,
)(InternalMultipleCreditForm);
